/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Extend dayjs with utc plugin
dayjs.extend(utc);
dayjs.extend(timezone);

export const getFormattedDate = (date: string = "", userTimezone: string = "UTC", format = "DD-MM-YYYY HH:mm") => {
  return dayjs(date).tz(userTimezone).format(format);
};
